import React from 'react';
import { MessageCircle } from 'lucide-react';
import './WhatsAppButton.css';

const WHATSAPP_NUMBER = '21671234567';
const WHATSAPP_MESSAGE = encodeURIComponent('Bonjour Tarjemlek, j\'ai besoin d\'une traduction assermentée.');

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
    >
      <MessageCircle size={28} />
    </a>
  );
}
